import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { ToasterService } from 'common/src/modules/ui-components/toaster';
import { AppState } from '../../store/state/app.state';
import { selectCompanyProfile } from '../../administration/store/selectors';
import { CompanyProfile } from '../../administration/models/company-profile.model';
import { FontModel, ResponseModel } from '../models';
import { DisplayToaster } from '../decorators/toaster';
import { environment } from '../../../environments/environment';
import { CommonModalsActionsEnum } from 'common/src/modules/modals/modals-common/common-modals-actions.enum';
import { DangerModalComponent } from 'common/src/modules/modals/modals-common/danger-modal/danger-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { PdfSettingsApiService } from '../../pdf-settings/services/pdf-settings-api.service';

@Injectable({providedIn: 'root'})
export class FontsApiService {

  // export const GENERAL_FONTS_LIST = [
  //   { value: 'INTER', label: 'Inter' },
  //   { value: 'COMFORTAA', label: 'Comfortaa' },
  //   { value: 'CRIMSON_PRO', label: 'CrimsonPro' },
  //   { value: 'GLUTEN', label: 'Gluten' },
  //   { value: 'JET_BRAINS_MONO', label: 'JetBrainsMono' },
  //   { value: 'JOSEFIN_SANS', label: 'JosefinSans' },
  //   { value: 'OXANIUM', label: 'Oxanium' },
  //   { value: 'ROBOTO_BOLD', label: 'Roboto' },
  //   { value: 'TEXTURIA', label: 'Texturina' },
  //   // { value: 'NEUE_PLANK_SEMIBOLD', label: 'Neue Plak-Semibold' },
  //   // { value: 'NEUE_PLANK_REGULAR', label: 'Neue Plak-Regular' },
  // ];
  //
  // export const HEADING_FONTS_LIST = [
  //   { value: 'BIO_RHYME_EXPANDED_BOLD', label: 'BioRhymeExpanded-Bold' },
  //   { value: 'BIO_RHYME_EXPANDED_LIGHT', label: 'BioRhymeExpanded-Light' },
  //   { value: 'BIO_RHYME_EXPANDED_REGULAR', label: 'BioRhymeExpanded-Regular' },
  //   { value: 'COMFORTAA_BOLD', label: 'Comfortaa-Bold' },
  //   { value: 'COMFORTAA_LIGHT', label: 'Comfortaa-Light' },
  //   { value: 'COMFORTAA_REGULAR', label: 'Comfortaa-Regular' },
  //   { value: 'CRIMSON_PRO_BOLD', label: 'CrimsonPro-Bold' },
  //   { value: 'CRIMSON_PRO_LIGHT', label: 'CrimsonPro-Light' },
  //   { value: 'CRIMSON_PRO_REGULAR', label: 'CrimsonPro-Regular' },
  //   { value: 'GLUTEN_BOLD', label: 'Gluten-Bold' },
  //   { value: 'GLUTEN_LIGHT', label: 'Gluten-Light' },
  //   { value: 'GLUTEN_REGULAR', label: 'Gluten-Regular' },
  //   { value: 'INTER_BOLD', label: 'Inter-Bold' },
  //   { value: 'INTER_LIGHT', label: 'Inter-Light' },
  //   { value: 'INTER_REGULAR', label: 'Inter-Regular' },
  //   { value: 'JET_BRAINS_MONO_BOLD', label: 'JetBrainsMono-Bold' },
  //   { value: 'JET_BRAINS_MONO_LIGHT', label: 'JetBrainsMono-Light' },
  //   { value: 'JET_BRAINS_MONO_REGULAR', label: 'JetBrainsMono-Regular' },
  //   { value: 'JOSEFIN_SANS_BOLD', label: 'JosefinSans-Bold' },
  //   { value: 'JOSEFIN_SANS_LIGHT', label: 'JosefinSans-Light' },
  //   { value: 'JOSEFIN_SANS_REGULAR', label: 'JosefinSans-Regular' },
  //   { value: 'OXANIUM_BOLD', label: 'Oxanium-Bold' },
  //   { value: 'OXANIUM_LIGHT', label: 'Oxanium-Light' },
  //   { value: 'OXANIUM_REGULAR', label: 'Oxanium-Regular' },
  //   { value: 'POPPINS_BOLD', label: 'Poppins-Bold' },
  //   { value: 'POPPINS_LIGHT', label: 'Poppins-Light' },
  //   { value: 'POPPINS_REGULAR', label: 'Poppins-Regular' },
  //   { value: 'ROBOTO_BOLD', label: 'Roboto-Bold' },
  //   { value: 'ROBOTO_LIGHT', label: 'Roboto-Light' },
  //   { value: 'ROBOTO_REGULAR', label: 'Roboto-Regular' },
  //   { value: 'TEXTURIA_BOLD', label: 'Texturina-Bold' },
  //   { value: 'TEXTURIA_LIGHT', label: 'Texturina-Light' },
  //   { value: 'TEXTURIA_REGULAR', label: 'Texturina-Regular' },
  //   // { value: 'NEUE_PLANK_SEMIBOLD', label: 'Neue Plak-Semibold' },
  // ];

  public generalFontsNamesList = {
    ['INTER']: 'Inter',
    ['COMFORTAA']: 'Comfortaa',
    ['CRIMSON_PRO']: 'CrimsonPro',
    ['GLUTEN']: 'Gluten',
    ['JET_BRAINS_MONO']: 'JetBrainsMono',
    ['JOSEFIN_SANS']: 'JosefinSans',
    ['OXANIUM']: 'Oxanium',
    ['ROBOTO']: 'Roboto',
    ['TEXTURIA']: 'Texturina'
  };

  public headingFontsNamesList = {
    ['BIO_RHYME_EXPANDED_BOLD']: 'BioRhymeExpanded-Bold',
    ['BIO_RHYME_EXPANDED_LIGHT']: 'BioRhymeExpanded-Light',
    ['BIO_RHYME_EXPANDED_REGULAR']: 'BioRhymeExpanded-Regular',
    ['COMFORTAA_BOLD']: 'Comfortaa-Bold',
    ['COMFORTAA_LIGHT']: 'Comfortaa-Light',
    ['COMFORTAA_REGULAR']: 'Comfortaa-Regular',
    ['CRIMSON_PRO_BOLD']: 'CrimsonPro-Bold',
    ['CRIMSON_PRO_LIGHT']: 'CrimsonPro-Light',
    ['CRIMSON_PRO_REGULAR']: 'CrimsonPro-Regular',
    ['GLUTEN_BOLD']: 'Gluten-Bold',
    ['GLUTEN_LIGHT']: 'Gluten-Light',
    ['GLUTEN_REGULAR']: 'Gluten-Regular',
    ['INTER_BOLD']: 'Inter-Bold',
    ['INTER_LIGHT']: 'Inter-Light',
    ['INTER_REGULAR']: 'Inter-Regular',
    ['JET_BRAINS_MONO_BOLD']: 'JetBrainsMono-Bold',
    ['JET_BRAINS_MONO_LIGHT']: 'JetBrainsMono-Light',
    ['JET_BRAINS_MONO_REGULAR']: 'JetBrainsMono-Regular',
    ['JOSEFIN_SANS_BOLD']: 'JosefinSans-Bold',
    ['JOSEFIN_SANS_LIGHT']: 'JosefinSans-Light',
    ['JOSEFIN_SANS_REGULAR']: 'JosefinSans-Regular',
    ['OXANIUM_BOLD']: 'Oxanium-Bold',
    ['OXANIUM_LIGHT']: 'Oxanium-Light',
    ['OXANIUM_REGULAR']: 'Oxanium-Regular',
    ['POPPINS_BOLD']: 'Poppins-Bold',
    ['POPPINS_LIGHT']: 'Poppins-Light',
    ['POPPINS_REGULAR']: 'Poppins-Regular',
    ['ROBOTO_BOLD']: 'Roboto-Bold',
    ['ROBOTO_LIGHT']: 'Roboto-Light',
    ['ROBOTO_REGULAR']: 'Roboto-Regular',
    ['TEXTURIA_BOLD']: 'Texturina-Bold',
    ['TEXTURIA_LIGHT']: 'Texturina-Light',
    ['TEXTURIA_REGULAR']: 'Texturina-Regular',
  };

  public fontsList$: BehaviorSubject<FontModel[]> = new BehaviorSubject<FontModel[]>([]);

  private wid: number;

  private apiUrl(url: string = ''): string {
    return `${environment.javaApiVersion}/workspaces/${this.wid}/fonts` + url;
  }

  constructor(
    private readonly toasterService: ToasterService,
    private readonly translateService: TranslateService,
    private readonly pdfSettingsApiService: PdfSettingsApiService,
    private readonly dialog: MatDialog,
    private readonly http: HttpClient,
    private readonly store: Store<AppState>,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.store.select(selectCompanyProfile)
      .subscribe((profile: CompanyProfile) => this.wid = profile.workspaceId);
  }

  public getFontsList(force = !this.fontsList.length): Observable<FontModel[]> {
    if (!force) {
      return this.fontsList$;
    }
    return this.http.get<ResponseModel<FontModel[]>>(this.apiUrl())
      .pipe(
        tap((response: ResponseModel<FontModel[]>) => this.fontsList$.next(response.data)),
        tap((response: ResponseModel<FontModel[]>) => this.loadDynamicFonts(response.data)),
        map((response: ResponseModel<FontModel[]>) => response.data)
      );
  }

  @DisplayToaster({showErrorMessage: true})
  public addFont(file: File): Observable<FontModel> {
    const formData = new FormData();
    formData.set('file', file);

    return this.http.post<ResponseModel<FontModel>>(this.apiUrl(), formData)
      .pipe(map((response: ResponseModel<FontModel>) => response.data));
  }

  @DisplayToaster({showErrorMessage: true})
  public deleteFont(fontId: number): Observable<null> {
    return this.http.delete<ResponseModel<null>>(this.apiUrl(`/${fontId}`))
      .pipe(map((response: ResponseModel<null>) => response.data)
    );
  }

  public deleteFontModal(fontId: number, fontName: string, pdfSettingsName?: string): void {
    this.dialog.open(DangerModalComponent, {
      data: {
        title: 'PDF_SETTINGS.DELETE_FONT_TTL',
        message: this.translateService.instant('PDF_SETTINGS.DELETE_FONT_MSG', {fontName}),
        confirmBtnText: 'BUTTON.DELETE',
        confirmBtnIcon: 'trash-2',
      }
    }).afterClosed()
      .subscribe((res: CommonModalsActionsEnum) => {
        if (res === CommonModalsActionsEnum.CONFIRM) {
          this.deleteFont(fontId)
            .pipe(
              switchMap(() => this.getFontsList(true)),
              switchMap(() => pdfSettingsName
                ? this.pdfSettingsApiService.getPdfSettings('CURRENT', pdfSettingsName)
                : of(null)
              ),
            )
            .subscribe();
        }
      });
  }

  get fontsList(): FontModel[] {
    return this.fontsList$.getValue();
  }

  loadDynamicFonts(fonts: FontModel[]): void {
    fonts.forEach((f: FontModel) => {
      if (!f.custom) { return; } // skip locally stored fonts

      const styleId = `font-${f.name.replace(/\s/g, '-')}-style`;

      // Prevent loading the same font multiple times
      if (this.document.getElementById(styleId)) {
        return;
      }

      const styleElement = this.document.createElement('style');
      styleElement.id = styleId;
      styleElement.innerText = `
      @font-face {
        font-family: '${f.name}';
        src: url('${environment.javaApiUrl}${environment.javaApiVersion}/public/fonts/${f.id}') format(${f.format});
        font-weight: 100 900;
        font-style: normal;
        font-display: swap;
      }
    `;

      this.document.head.appendChild(styleElement);
    });

  }

}
